import { BACKEND_WEBSOCKET_HOST } from "../../config";

const connectSocket = (path, connectionOpen, connectionClose) => {
  return function (dispatch) {
    const ws_path = BACKEND_WEBSOCKET_HOST + path;

    const chatSocket = new WebSocket(ws_path);

    chatSocket.onopen = () => {
      dispatch(connectionOpen(chatSocket));
    };
    chatSocket.onclose = () => {
      dispatch(connectionClose(chatSocket));
    };
  };
};

export default connectSocket;
